import dayjs from 'dayjs';
import type { DashboardMetrics, WorkbenchState } from './types';

const isOpen = (status: string) =>
  !['completed', 'cancelled', 'reminder'].includes(status);

export const selectDashboardMetrics = (
  state: WorkbenchState,
): DashboardMetrics => {
  const today = dayjs(state.generatedAt).format('YYYY-MM-DD');
  return {
    todayTasks: state.workItems.filter(
      (item) =>
        isOpen(item.status) &&
        item.dueAt &&
        dayjs(item.dueAt).format('YYYY-MM-DD') === today,
    ).length,
    overdueTasks: state.workItems.filter(
      (item) =>
        isOpen(item.status) &&
        Boolean(item.dueAt) &&
        dayjs(item.dueAt).isBefore(dayjs(state.generatedAt)),
    ).length,
    todayMeetings: state.schedules.filter(
      (item) => item.date === today && !item.completed,
    ).length,
    pendingDecisions: state.workItems.filter(
      (item) =>
        isOpen(item.status) &&
        /决策|审批|投决/.test(`${item.type}${item.title}`),
    ).length,
    highRisks: selectHighRiskCount(state),
    focusedObjects: state.focusObjects.length,
  };
};

export const selectHighRiskCount = (state: WorkbenchState) =>
  state.sourceEntities.filter(
    (item) => item.riskLevel === 'high' && !item.riskHandled,
  ).length;

export const selectEntity = (state: WorkbenchState, id?: string) =>
  state.sourceEntities.find((item) => item.id === id);

export const selectFocusedActivities = (state: WorkbenchState) => {
  const ids = new Set(state.focusObjects.map((item) => item.entityId));
  return state.activities.filter(
    (item) => item.entityId && ids.has(item.entityId),
  );
};

export const selectTodayWorkItems = (state: WorkbenchState) => {
  const today = dayjs(state.generatedAt).format('YYYY-MM-DD');
  return state.workItems
    .filter(
      (item) =>
        isOpen(item.status) &&
        item.dueAt &&
        dayjs(item.dueAt).format('YYYY-MM-DD') === today,
    )
    .sort((a, b) => (a.dueAt ?? '').localeCompare(b.dueAt ?? ''));
};

export const selectTodaySchedules = (state: WorkbenchState) => {
  const today = dayjs(state.generatedAt).format('YYYY-MM-DD');
  return state.schedules
    .filter((item) => item.date === today)
    .sort((a, b) => a.startTime.localeCompare(b.startTime));
};

export const selectActiveReminders = (state: WorkbenchState) =>
  state.reminders.filter(
    (item) => !['ignored', 'snoozed'].includes(item.status),
  );
